import { render } from "./Pending_task.vue?vue&type=template&id=4374af4d&scoped=true"
import script from "./Pending_task.vue?vue&type=script&lang=js"
export * from "./Pending_task.vue?vue&type=script&lang=js"

import "./Pending_task.vue?vue&type=style&index=0&id=4374af4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4374af4d"]])

export default __exports__